import PageBuilder from '@/models/PageBuilder'
import Api from '@/services/api'
import map from 'lodash/map'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {},
    articleDetails: {},
    requestStatus: '',
    requestMsg: '',
    optionList: []
  },

  mutations: {
    setRequestStatus (state, payload) {
      state.requestMsg = payload.msg
      state.requestStatus = payload.status
    },

    setList (state, records) {
      state.list = []
      state.list = map(records, record => {
        if (record instanceof PageBuilder) {
          return record
        } else {
          return new PageBuilder(record)
        }
      })
    },

    setListMeta (state, meta) {
      state.listMeta = meta
    },

    refreshList (state) {
      state.list = []
    },
    setOptionList (state, data) {
      state.optionList = []
      map(data, record => {
        state.optionList.push(
          {
            text: record.title,
            value: record.id,
            thumbnail: record.thumbnail
          }
        )
      })
    }
  },

  actions: {
    async getList ({ commit }, params) {
      let perPage = 20
      if (params.per_page) {
        perPage = params.per_page
      }
      const query = PageBuilder.page(params.page || 1)
        .orderBy(params.sort)

      if (perPage === 'all') {
        query.params({ limit: 'all' })
      } else {
        query.limit(perPage)
      }

      const res = await query.get()

      commit('setList', res.data)
      commit('setListMeta', res.meta)
      commit('setOptionList', res.data)
    },

    // async update ({ commit }, params) {
    //   const config = {
    //     headers: { 'content-type': 'multipart/form-data' }
    //   }
    //   let id = params.get('id')
    //   await Api.post(`admin/free-to-play/live/${id}`, params, config)
    //     .then(response => {
    //       let payload = { msg: 'Poll updated.', status: 'success' }
    //       commit('setRequestStatus', payload)
    //     })
    //     .catch(error => {
    //       let payload = { msg: error.response.data.message, status: 'error' }
    //       commit('setRequestStatus', payload)
    //     })
    // },

    async delete ({ commit }, id) {
      await Api.delete(`admin/page-builders/${id}`)
        .then(response => {
          let payload = { msg: 'Record Deleted.', status: 'error' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteHeroImage ({ commit }, id) {
      await Api.delete(`admin/page-builders/${id}/banner`)
        .then(response => {
          let payload = { msg: 'Hero Image Removed.', status: 'error' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async deleteMobileHeroImage ({ commit }, id) {
      await Api.delete(`admin/page-builders/${id}/banner-mobile`)
        .then(response => {
          let payload = { msg: 'Mobile Hero Image Removed.', status: 'error' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    },

    async clone ({ commit }, id) {
      await Api.post(`admin/page-builders/${id}/duplicate`)
        .then(response => {
          let payload = { msg: 'Record Duplicated!', status: 'success' }
          commit('setRequestStatus', payload)
        })
        .catch(error => {
          let payload = { msg: error.response.data.message, status: 'error' }
          commit('setRequestStatus', payload)
        })
    }
  }
}
